var MODULE = (function (library, $) {
    var REIFEN = {

        API:{
            CALL_FORM_FRAGMENT:{url:"/search/fragment", method:"GET"},
            CALL_SEARCH:{url:"/search", method:"GET"},
            CALL_BRAND_INFO:{url:"/delticom/brand/proxy", method:"GET"}
        }

    };

    var urlParameter = function (name) {
        name = name.replace(/[\[]/, "\\\[").replace(/[\]]/, "\\\]");
        var regex = new RegExp("[\\?&]" + name + "=([^&#]*)");
        var results = regex.exec(window.location.search);
        return results ? decodeURIComponent(results[1]) : "";
    };

    function removeVariableFromURL(url, variableName) {
        var URL = String(url);
        var regex = new RegExp("\\?" + variableName + "=[^&]*&?", "gi");
        URL = URL.replace(regex, '?');
        regex = new RegExp("\\&" + variableName + "=[^&]*&?", "gi");
        URL = URL.replace(regex, '&');
        URL = URL.replace(/(\?|&)$/, '');
        regex = null;
        return URL;
    }

    var removeUrlParameter = function (url, parameter) {
        var urlparts = url.split('?');
        if (urlparts.length >= 2) {

            var prefix = encodeURIComponent(parameter) + '=';
            var pars = urlparts[1].split(/[&;]/g);
            for (var i = pars.length; i-- > 0;)
                if (pars[i].lastIndexOf(prefix, 0) !== -1)
                    pars.splice(i, 1);
            url = urlparts[0] + '?' + pars.join('&');
        }
        return url;
    };

    var appendParamToUrl = function (key, value) {
        var kvp = document.location.search.substr(1).split('&');
        var i = kvp.length;
        var x;
        while (i--) {
            x = kvp[i].split('=');
            if (x[0] == key) {
                x[1] = value;
                kvp[i] = x.join('=');
                break;
            }
        }
        if (i < 0) {
            kvp[kvp.length] = [ key, value ].join('=');
        }
        document.location.search = kvp.join('&');
    };

    var appendParamToSpecUrl = function (url, key, value) {
        var kvp = url.split('&');
        var i = kvp.length;
        var x;
        while (i--) {
            x = kvp[i].split('=');
            if (x[0] == key) {
                x[1] = value;
                kvp[i] = x.join('=');
                break;
            }
        }
        if (i < 0) {
            kvp[kvp.length] = [ key, value ].join('=');
        }
        return kvp.join('&');
    };

    var urlDecode = function (str) {
        return decodeURIComponent((str + '').replace(/\+/g, '%20'));
    };

    library.REIFEN = REIFEN;
    library.urlParameter = urlParameter;
    library.appendParamToUrl = appendParamToUrl;
    library.appendParamToSpecUrl = appendParamToSpecUrl;
    library.removeUrlParameter = removeUrlParameter;
    library.removeVariableFromURL = removeVariableFromURL;
    library.urlDecode = urlDecode;

    return library;

}(MODULE || {}, jQuery));

var TooltipJS = (function ($) {

    var bindEvents = function (tooltipSel, dotdotContainerSel) {
        $(document).on("mouseover", tooltipSel, function() {
            var contentId = $("#" + $(this).attr("data-content-id"))[0];
            if ($(this).data("sticky") === true) {
                if(contentId !== undefined){
                    var overlibR = overlib(contentId['outerHTML'], STICKY, MOUSEOFF);
                }
                MainJS.initDotDotDot(dotdotContainerSel);
                return overlibR;
            } else {
                if(contentId !== undefined){
                    var overlibR = overlib(contentId['outerHTML']);
                }
                MainJS.initDotDotDot(dotdotContainerSel);
                return overlibR;
            }
        });

        $(document).on("mouseout", tooltipSel, function() {
            return nd();
        });

    };

    return {
        bindEvents: bindEvents
    };
}) (jQuery);

var MainJS = (function ($) {

    var ajaxCall = function (url, type, callData, successCallback, errorCallback, extraParams) {
        return untrackedAjaxCall(url, type, callData, successCallback, errorCallback, extraParams);
    };

    var untrackedAjaxCall = function (url, type, callData, successCallback, errorCallback, extraParams) {
        var result;
        var ajaxSettings = {
            type: type,
            cache: extraParams.cache,
            async: extraParams.async,
            contentType: extraParams.contentType,
            data : callData,
            success: function(data, textStatus, jqXHR) {
                if (successCallback) {
                    successCallback(data);
                }
                result = data;
            },
            error: function (jqXHR, textStatus, errorThrown) {
                if (errorCallback) {
                    errorCallback();
                }
            }
        }

        $.smartAjax(url,ajaxSettings);

        return result;
    };

    var getFooterHeight = function () {
        return $('.hidden-phone').outerHeight()
            + $('.copyright').outerHeight()
            + $('.footer-bar').outerHeight()
            + $('.footer-links').outerHeight()
            + $('.footer.flags').outerHeight();
    };

    var initFancyVideos = function () {
        $(".j-yout-video").on('click', function() {
        	currentProtocol = window.location.protocol;
        	preparedVideoURL = this.href.replace(new RegExp("watch\\?v=", "i"), 'embed/').replace(new RegExp("http:", "i"), currentProtocol);
            $.fancybox({
                'padding'		: 0,
                'autoScale'		: true,
                'transitionIn'	: 'none',
                'transitionOut'	: 'none',
                'width'         : '80%',
                'height'        : '80%',
                'title'			: '',
                'href'			: preparedVideoURL,
                'type'			: 'iframe',
                helpers : {
                    overlay : {
                        locked : false
                    }
                },
                'swf'			: {
                    'wmode'				: 'transparent',
                    'allowfullscreen'	: 'true'
                }
            });

            return false;
        });
    };




    var initDotDotDot = function (containerSel, options) {
        if (options) {
            $(containerSel).dotdotdot(options);
        } else {
            $(containerSel).dotdotdot({
                ellipsis	: '... '
            });
        }
    };

    var initDatePicker = function (datePickerSel) {
        $(datePickerSel).datepicker({
            minDate: new Date(1910, 1 - 1, 1),
            maxDate: new Date(2110, 1, -1, 1),
            yearRange: '-100:+0',
            changeYear: true
        });
    };

    var errorListWaitAndFadeOut = function () {
        setTimeout(function () {
            errorListFadeOut();
        }, 5000);
    };

    var errorListFadeOut = function () {
        var parent = $("#messageList");
        if(parent.children().length > 0) {
            $("#messageList :first-child").animate({ height: 'toggle', opacity: 'toggle' }, 'slow', function() {
                this.remove();
                errorListFadeOut();
            });
        }else{
            parent.remove();
        }
    };

    return {
        ajaxCall: ajaxCall,
        untrackedAjaxCall: untrackedAjaxCall,
        initFancyVideos: initFancyVideos,
        getFooterHeight: getFooterHeight,
        errorListWaitAndFadeOut: errorListWaitAndFadeOut,
        initDatePicker: initDatePicker,
        initDotDotDot: initDotDotDot
    };
}) (jQuery);


jQuery.fn.preventDoubleSubmission = function() {
    $(this).on('submit',function(e){
        var $form = $(this);

        if ($form.data('submitted') === true) {
            e.preventDefault();
        } else {
            $form.data('submitted', true);
        }
    });

    return this;
};

var PopupComponentJS = (function ($) {

    var initPopupComponents = function (eSel) {
        if($(eSel).length > 0) {
            bindModalWindows(eSel);
        }
    };

    var bindModalWindows = function (eSel) {
        $(eSel + " > a," + eSel + " p > a").on("click", function(e) {
            e.preventDefault();

            var paragraph = $(this).data("paragraph");
            location.hash = "";

            MainJS.ajaxCall($(this).attr("href"), "GET", null, function(data) {
                var parseData = new DOMParser().parseFromString(data, 'text/html');
                var contentMain = $(parseData).find('#main');
                $.fancybox({
                    width: 980,
                    height: 700,
                    fitToView : true,
                    autoSize : false,
                    content : contentMain.length > 0 ? contentMain : data,
                    wrapCSS : $(eSel).data('wrapCss'),
                    helpers : {
                        overlay : {
                            locked : false
                        }
                    },
                    afterClose: function () {
                        location.hash = "";
                    },
                    afterShow: function () {
                        setTimeout(function () {
                            if (paragraph === undefined) {
                                return;
                            }

                            location.hash = paragraph;
                        }, 0);
                    }
                });
            }, null, {});
        });
    };

    return {
        initPopupComponents: initPopupComponents,
        bindModalWindows: bindModalWindows
    }
}) (jQuery);



function initStickyFilterBox() {
    if($("div").is(".search-result-left.search-result-left-float")) {
        $(window).on('resize scroll load', function () {
            var $searchResultLeft = $(".search-result-left");
            if (($searchResultLeft.width() < 270) && ($('.search-result-right').height() > $searchResultLeft.height())) {
                var $scrollt = $(document).scrollTop();
                var $height_footer = MainJS.getFooterHeight();
                var $fullheight = $(document).height() - $searchResultLeft.height() - $height_footer;

                if (($scrollt > 230) && ($scrollt < $fullheight)) {
                    $searchResultLeft.removeAttr("style");
                    $searchResultLeft.css({"position": "fixed", "top": "0px"});
                    $searchResultLeft.find('.tab-content.results-filters').css({"max-height" : $(window).outerHeight() - 110, "overflow-y" : "auto"});
                }
                else {
                    $searchResultLeft.removeAttr("style");
                     $searchResultLeft.find('.tab-content.results-filters').removeAttr("style");
                }
                if ($scrollt > $fullheight) {
                    $searchResultLeft.removeAttr("style");
                    $searchResultLeft.css({"position": "absolute", "bottom": 0});
                }
            }
            else {
                $searchResultLeft.removeAttr("style");
            }
        });
    }
    if($("div").is(".columns.filters.search-result-left-float")) {
        var sticky =  $('#facetsidebar');
        $(window).on('resize scroll load', function () {
            if ((sticky.width() < 270) && ($('#right-container').height() > sticky.height())) {
                var $scrollt = $(document).scrollTop();
                var $height_footer = MainJS.getFooterHeight();
                var $fullheight = $('#right-container').height() - $height_footer;
                if (($scrollt > 320) && ($scrollt < $fullheight)) {
                    sticky.removeAttr("style");
                    sticky.css({"position": "fixed", "top": "0px", "margin-top": "0px", "width": sticky.outerWidth()});
                }
                else {
                    sticky.removeAttr("style");
                    if ($scrollt > $fullheight) {
                        sticky.css({"position": "absolute", "bottom": "25px"});
                    }
                }

            }
            else {
                sticky.removeAttr("style");
            }
        });
    }
} (jQuery);

//make tables responsive for mobile devices
function responsiveTables() {
    var headertext = [],
        headers = document.querySelectorAll(".responsive_content_table th"),
        tablebody = document.querySelector(".responsive_content_table tbody"),
        tabletdHTML = document.querySelectorAll(".responsive_content_table tbody td");

    //wrap content in td
    for(var i = 0; i < tabletdHTML.length; i++){
        var textHTML = '<div class="wrapper-td-content">' + tabletdHTML[i].innerHTML + '</div>';

        tabletdHTML[i].innerHTML = textHTML;
    }
    for(var i = 0; i < headers.length; i++) {
        var current = headers[i];
        headertext.push(current.textContent.replace(/\r?\n|\r/,""));
    }
    //add data attribute for td, data attr contain names fields th
    for (var i = 0, row; row = tablebody.rows[i]; i++) {
        for (var j = 0, col; col = row.cells[j]; j++) {
            col.setAttribute("data-th", headertext[j]);
        }
    }
}

jQuery(document).ready(function () {
    var dotdotContainerSel = ".dotdot-overflow";
    TooltipJS.bindEvents(".j-icon-tooltip", dotdotContainerSel);
    $("form.j-single-submission").preventDoubleSubmission();
    MainJS.initFancyVideos();
    initStickyFilterBox();
    MainJS.initDatePicker('.datepicker');
    $(".datepicker").datepicker("setDate", new Date());
    MainJS.errorListWaitAndFadeOut();
    MainJS.initDotDotDot(dotdotContainerSel);
    PopupComponentJS.initPopupComponents(".j-paragraph-modal");

    //check if page exist table with class 'responsive_content_table'
    if(document.getElementsByClassName('responsive_content_table').length > 0){
        responsiveTables();
    }
});

$.smartAjax = function(url, settings) {
    if ( !settings ) {
        settings = {};
    }

    var theirBeforeSend = settings['beforeSend'];
    var theirSuccess = settings['success'];
    var internalXhr;

    settings['beforeSend'] = function(jqxhr, jqsettings) {
        internalXhr = jqsettings.xhr();
        jqsettings.xhr = function() { return internalXhr; }

        // call their original callback, if any
        if ( theirBeforeSend ) {
            return theirBeforeSend(jqxhr, jqsettings);
        }
    };

    settings['success'] = function(data, status, jqxhr) {
        if ( internalXhr.responseURL !== undefined &&
            typeof internalXhr.responseURL.endsWith == 'function' &&
            internalXhr.responseURL.endsWith('login') )
        {
            console.log('Redirected to login.');
            location.reload();
            return;
        }

        // call their original callback, if any
        if ( theirSuccess ) {
            return theirSuccess(data, status, jqxhr);
        }
    };

    return $.ajax(url, settings);
}
